(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parcel-tracking"]) return;
  try {
    
  (function () {
    var form = document.querySelector('[data-parcel-lookup]');
    if (!form) return;
    var msg = form.querySelector('[data-parcel-msg]');
    var tabs = document.querySelectorAll('[data-mode]');
    var mode = 'tracking';

    function setMode(m) {
      mode = m;
      tabs.forEach(function (t) {
        t.setAttribute('aria-selected', t.dataset.mode === m ? 'true' : 'false');
      });
      form.querySelectorAll('[data-panel]').forEach(function (p) {
        p.hidden = p.dataset.panel !== m;
      });
      msg.textContent = '';
    }
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        setMode(t.dataset.mode);
      });
    });

    function say(text) {
      msg.textContent = text;
    }

    // Must match handle_for() in shopify_agent/scripts/tracking_sync.py.
    function parcelHandle(raw) {
      return (raw || '').replace(/\s+/g, '').toLowerCase().replace(/[^a-z0-9-]/g, '');
    }

    // Must match order_handle() in tracking_sync.py: sha256 of
    // "zohella-order|<digits of the order number>|<email, trimmed, lower case>", first 40 hex.
    function orderHandle(order, email) {
      var key = 'zohella-order|' + order.replace(/\D/g, '') + '|' + email.trim().toLowerCase();
      return crypto.subtle.digest('SHA-256', new TextEncoder().encode(key)).then(function (buf) {
        return Array.from(new Uint8Array(buf))
          .map(function (b) {
            return b.toString(16).padStart(2, '0');
          })
          .join('')
          .slice(0, 40);
      });
    }

    function byTracking(raw) {
      var h = parcelHandle(raw);
      if (!h) return say('הזיני את מספר המעקב שלך.');
      say('מחפשים…');
      var url = '/pages/track/' + h;
      fetch(url, { credentials: 'same-origin' })
        .then(function (r) {
          if (r.ok) return window.location.replace(url);
          say(
            'עדיין אין עדכונים למספר הזה. חבילה שנשלחה עכשיו מופיעה כאן תוך כמה שעות. בדקי את המספר ונסי שוב מאוחר יותר.'
          );
        })
        .catch(function () {
          say('משהו השתבש. נסי שוב בעוד רגע.');
        });
    }

    function byOrder(order, email) {
      if (!order.replace(/\D/g, '') || email.indexOf('@') < 1) {
        return say('מלאי גם מספר הזמנה וגם כתובת אימייל.');
      }
      say('מחפשים…');
      orderHandle(order, email)
        .then(function (h) {
          return fetch('/pages/order/' + h, { credentials: 'same-origin' });
        })
        .then(function (r) {
          if (!r.ok) {
            say(
              'לא מצאנו הזמנה עם מספר ההזמנה וכתובת האימייל האלה. בדקי את הפרטים והשתמשי באותה כתובת אימייל שבה הזמנת.'
            );
            return null;
          }
          return r.text();
        })
        .then(function (html) {
          if (html === null || html === undefined) return;
          var el = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-order-lookup]');
          var parcels = el ? JSON.parse(el.getAttribute('data-parcels') || '[]') || [] : [];
          if (parcels.length === 1) return window.location.replace('/pages/track/' + parcels[0].handle);
          if (parcels.length === 0) {
            return say('ההזמנה שלך התקבלה ואנחנו מכינים אותה למשלוח. כשהיא תישלח תוכלי לעקוב אחריה כאן.');
          }
          msg.textContent = '';
          var p = document.createElement('p');
          p.textContent = 'ההזמנה שלך נשלחת ב-' + parcels.length + ' חבילות:';
          var ul = document.createElement('ul');
          ul.className = 'parcel__list';
          parcels.forEach(function (x, i) {
            var li = document.createElement('li');
            var a = document.createElement('a');
            a.href = '/pages/track/' + x.handle;
            a.textContent = 'חבילה ' + (i + 1) + ': ' + x.number;
            a.dir = 'auto';
            li.appendChild(a);
            ul.appendChild(li);
          });
          msg.appendChild(p);
          msg.appendChild(ul);
        })
        .catch(function () {
          say('משהו השתבש. נסי שוב בעוד רגע.');
        });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (mode === 'order') {
        byOrder(form.elements.order.value, form.elements.email.value);
      } else {
        byTracking(form.elements.nr.value);
      }
    });

    var nr = new URLSearchParams(window.location.search).get('nr');
    if (nr) {
      form.elements.nr.value = nr;
      byTracking(nr);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
